var base_url="https://blutoothbrush.aliansoftware.net/public/";
var templatename=template_name;
var pro_price=product_price;
var pro_tags=tags;
var store_url=store_url;
var com_price=pro_compare_price;
var pro_id=product_id;
var cart_total=cart_total;

$(document).ready(function(){
	debugger;
  	if(templatename == "product"){
        var brush_type="";
        if(pro_tags.indexOf("kids") != -1){
            brush_type="kids";
        }
        if(pro_tags.indexOf("adults") != -1){
            brush_type="adults";
        }
    	$('.loader_image').show();	
      	 $.ajax({
              url: '/cart.js',
              method: "GET",
              dataType: "json",
             async: false,
              success: function (response) {
              	debugger;
                if(response.items.length == 1){
                	var old_token=getCookie('cart_token')
                    $.ajax({
                          url: base_url + 'updatetoken',
                          method: "GET",
                          dataType: "json",
                      	  data:{token:old_token,new_token:response.token},
                         async: false,
                          success: function (Data) {
                          	debugger;
                            $.ajax({
                                    url: base_url + 'Getplan',
                                    method: "GET",
                                    dataType: "json",
                                    data:{brush_type:brush_type},
                                   async: false,
                                    success: function (res) {
                                        debugger;
                                      $('.add_to_cart').after("<input type='hidden' id='selected_plan' value='Every 3 Months'>");
                                      var count=res.length;
                                      var price_section='';
                                      var plan_setting='';
                                      
                                      var save_amt=0;
                                      
                                      var option='<div id="plan_section">';
                                      var description='';
                                      plan_setting +="<div id='refill_plans'><label><input type='radio' name='subscription_or_not' id='1' class='Planname' value='Refill plan' checked><span for='1' class='redio_button'></span>Refill plan</label>";
                                      plan_setting+= "<label><input type='radio' id='2' name='subscription_or_not' class='Planname' value='One-time purchase'><span for='2' class='redio_button'></span>One-time purchase</label></div>"; 
                                      var plan_check='';
                                   	  $('#add_to_cart_div').before(plan_setting);	 
                                      if(count > 0){
                                          for(var i=0;i<count;i++){

                                            if(res[i].duration == '3'){
                                                var plan_check = "checked";
                                            }
                                            description+='<div class="plan_description_'+res[i].duration+'">'+res[i].plan_description+'</div>';
                                            option +="<a href='javascript:void(0)' name='plan_name' class='month_plan' "+plan_check+">Every  "+res[i].plan_name+"</a></br>";
                                            price_section +='<div  class="product_price price_plan_'+res[i].duration+'"><span>$'+res[i].plan_price+'<small>Today</small><strike>$'+pro_price+'</strike></span><span class="dec_price">$'+res[i].recurring_price+'<small>Your next refill</small></span><span>Free<small>Shipping</small></span></div>';
                                        	save_amt = res[i].plan_price; 
                                          }

                                           option +='</div>';

                                          var one_time="<div class='one_time_purchase product_price' style='display:none;'><span>$"+pro_price+"<strike>$"+pro_price+"</strike><small>Today</small></span><span class='dec_price'>$10*<small>Shipping Rate</small></span></div>";
										  var save_amount = parseFloat(pro_price - save_amt);
										   var amount=save_amount.toFixed(2);		
										  
                                          $('#refill_plans').after(option);
                                          $('#plan_section').before(description);
                                          $('#plan_section').after(one_time);
                                          $('#add_to_cart_div').before(price_section);
                                          $('.price_plan_3').after("<div class='save_amount'>$"+amount+"  total set savings</div>");	
                                      }else{
                                        $('#refill_plans').after("<div id='plan_section'><span style='color:red'>plan is not set</span></div>");
                                      }


                                      $('.price_plan_12').hide();
                                      $('.plan_description_12').hide();
                                      
                                      $('.loader_image').hide();

                                    },
                                    error:function(){
                                     console.log('error');
                                    }
                             });
                         	
                          
                          },
                          error:function(){
							console.log("error");
                          }
                    });
 
                }else{
                	$.ajax({
                          url: base_url + 'Getplan',
                          method: "GET",
                          dataType: "json",
                          data:{brush_type:brush_type},
                         async: false,
                          success: function (res) {
                              debugger;
                            $('.add_to_cart').after("<input type='hidden' id='selected_plan' value='Every 3 Months'>");
                            var count=res.length;
                            var price_section='';
                            var plan_setting='';
                            
                             var save_amt=0;
                            
                            var option='<div id="plan_section">';
                            var description='';
                            plan_setting +="<div id='refill_plans'><label><input type='radio' name='subscription_or_not' id='1' class='Planname' value='Refill plan' checked><span for='1' class='redio_button'></span>Refill plan</label>";
                            plan_setting+= "<label><input type='radio' id='2' name='subscription_or_not' class='Planname' value='One-time purchase'><span for='2' class='redio_button'></span>One-time purchase</label></div>"; 
                            var plan_check='';
                           $('#add_to_cart_div').before(plan_setting);	 
                            if(count > 0){
                                  for(var i=0;i<count;i++){

                                    if(res[i].duration == '3'){
                                        var plan_check = "checked";
                                    }
                                    description+='<div class="plan_description_'+res[i].duration+'">'+res[i].plan_description+'</div>';
                                    option +="<a href='javascript:void(0)' name='plan_name' class='month_plan' "+plan_check+">Every  "+res[i].plan_name+"</a></br>";
                                    price_section +='<div  class="product_price price_plan_'+res[i].duration+'"><span>$'+res[i].plan_price+'<strike>$'+pro_price+'</strike><small>Today</small></span><span class="dec_price">$'+res[i].recurring_price+'<small>Your next refill</small></span><span>Free<small>Shipping</small></span></div>';
                                	save_amt = res[i].plan_price; 
                                  }

                                   option +='</div>';

                                  var one_time="<div class='one_time_purchase product_price' style='display:none;'><span>$"+pro_price+"<small>Today</small></span><span class='dec_price'>$10*<small>Shipping Rate</small></span></div>";

								  var save_amount = parseFloat(pro_price - save_amt);
										  	
								  var amount=save_amount.toFixed(2);	

                                  $('#refill_plans').after(option);
                                  $('#plan_section').before(description);
                                  $('#plan_section').after(one_time);
                                  $('#add_to_cart_div').before(price_section);
                              	  $('.price_plan_3').after("<div class='save_amount'>$"+amount+"  total set savings</div>");	
                              }else{
                                $('#refill_plans').after("<div id='plan_section'><span style='color:red'>plan is not set</span></div>");
                              }


                              $('.price_plan_12').hide();
                              $('.plan_description_12').hide();
                            $('.loader_image').hide();

                            },
                            error:function(){
                             console.log('error');
                            }
                     });
                
                }	
                
                                
              },
              error:function(){
				console.log("error");
              } 
         });
      
    
  		 
  }
  
  
  $('.Planname').on('change',function(){
  		debugger;
    var plan_name=$(this).val();
    
    $('#selected_plan').val('');
    $('#selected_plan').val(plan_name);
    
    if(plan_name == "Refill plan"){
      
      $('.one_time_purchase').hide();
      $(this).closest('#discription').find('#plan_section').show();
      if($(this).closest('#discription').find('.plan_description_3').length == 1)	{
          $(this).closest('#discription').find('.plan_description_3').show();
          $(this).closest('#discription').find('.price_plan_3').show();
        $(this).closest('#discription').find('.save_amount').show();
      }else{
          $(this).closest('#discription').find('.plan_description_12').show();
        $(this).closest('#discription').find('.price_plan_12').show();


      }
      
      
    }else{
     	
      	
        
			 $('.one_time_purchase').show();
      		$(this).closest('#discription').find('.save_amount').hide();
      
           $(this).closest('#discription').find('#plan_section').hide();


          $(this).closest('#discription').find('.plan_description_3').hide();
            $(this).closest('#discription').find('.price_plan_3').hide();

              $(this).closest('#discription').find('.plan_description_12').hide();
            $(this).closest('#discription').find('.price_plan_12').hide();
    }
    
    
        
            if(plan_name == "Refill plan"){
              $('.meta_img').addClass('active');
            }else{
             $('.meta_img').removeClass('active');
            }
        
    
  });
  
  
  $('.month_plan').on('click',function(){
  			debugger;
    var planname=$(this).text();
    
    $('#selected_plan').val('');
    $('#selected_plan').val(planname);
    
    if(planname == "Every  12 Months"){
    	$(this).closest('#discription').find('.plan_description_12').show();
      	$(this).closest('#discription').find('.price_plan_12').show();
      
      	$(this).closest('#discription').find('.plan_description_3').hide();
         $(this).closest('#discription').find('.price_plan_3').hide();
      
    }else{
    	$(this).closest('#discription').find('.plan_description_3').show();
          $(this).closest('#discription').find('.price_plan_3').show();
      
      	$(this).closest('#discription').find('.plan_description_12').hide();
      	$(this).closest('#discription').find('.price_plan_12').hide();
    
    }
  	
  })
  
  function setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        }
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ')
              c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0)
              return c.substring(nameEQ.length, c.length);
      }
      return null;
  }

  
  
  $('.add_to_cart').on('click',function(e){
    debugger;
  		e.preventDefault();
    var plan=$('#selected_plan').val();
    var refill_or_not=$('input[name=subscription_or_not]:checked').val();
   	$('.add_to_cart').attr('disabled',true); 	
     
    $.ajax({
            url: '/cart.js',
            method: "GET",
            dataType: "json",
            async: false,
            success: function (response) {
                debugger;
              var gettoken = response.token;
              setCookie('cart_token', gettoken, 365);
              
              $.ajax({
                    url: base_url + 'Checkplandetails',
                    method: "GET",
                    dataType: "json",
                    async: false,
                	data: {'token_cart': gettoken},
                    success: function (data) {
                      debugger;
                      var id=0;
                      if(data.id == 0){
                      	id=0;
                      }else{
                      	id=data.id;
                      }	
                      
                        $.ajax({
                            url: base_url + 'Saveplandetails',
                            method: "GET",
                            dataType: "json",
                            async: false,
                          	data: {'token_cart': gettoken,'plan':plan,'id':id,'product_id':pro_id},
                            success: function (result) {
                              debugger;
                              $('.loader').hide();
                              $('form[action="/cart/add"]').submit();
                            },
                            error:function(){
                                console.log("error");
                            }
                       });
              
                      
                    },
                    error:function(){
                    	console.log("error");
                    }
               });
              
              
             
            },
            error:function(){
            	console.log("error");
            }
    
    
 	 });
  });
  
  
  $('#checkout').on('click',function(e){
  		debugger;
           	
    	e.preventDefault();
    	
   
    if($('#planname').val() != "0"){
      $('#checkout').attr('disabled',true);
    		 $.ajax({
            url: '/cart.js',
            method: "GET",
            dataType: "json",
            async: false,
            success: function (response) {
                debugger;
              var gettoken = response.token;
              
               $.ajax({
                    url: base_url + 'CheckMetaData',
                    method: "GET",
                    dataType: "json",
                    async: false,
                    data: {'shopname': store_url, 'token_cart': gettoken},
                    success: function (result) {
                    	debugger;
                      var metavalue=[];
                      var plan_prod=[];
                      var metaid=0;
                      if(result){
                         metaid=result.id;	
                      }else{
                      	metaid=0;
                      } 
                      	var brush_type='';
                       var item_len=response.items.length;
                        var plan="3 Months";
                        for(var k =0;k<item_len;k++){
                            var pro_type=response.items[k].product_type;
                            if(pro_type.indexOf("kids") != -1){
                                brush_type="kids"
                            }
                            if(pro_type.indexOf("adults") != -1){
                                brush_type="adults"
                            }
                          
                          
                            if(brush_type == "kids" || brush_type == "adults"){
                              brush_type=response.items[k].product_type;
                             var product_id=response.items[k].product_id;
                             var variant_id=response.items[k].variant_id;
						     var sub_pro_id=parseInt(document.getElementsByClassName('item_id')[k].value);
                              
                             $.ajax({
                                      url: base_url + 'PlanName',
                                      method: "GET",
                                      dataType: "json",
                                      data:{cart_token:gettoken,'pro_id':response.items[k].product_id},
                                      async: false,
                                      success: function (data) {
                                        debugger;
										var planname="";
                                        if(data.plan_name == "3 Months" || data.plan_name == "12 Months"){
                                        	planname="Refill plan";
                                        }else{
                                        	planname="One-time purchase";
                                        }
                                        
                                        plan_prod.push({'product_id':product_id,'variant_id':variant_id,'brush_type':brush_type,sub_pro_id:sub_pro_id,'refill_or_not':planname});
                                        
                                      },
                                      error:function(){

                                      }
                                  });
                             

                            }
						}
                      
                      	metavalue.push({'plan':plan,'plan_prod':plan_prod});
                      
                    	console.log(metavalue);	  
                        
                      	 $.ajax({
                                url: base_url + 'SaveMetaData',
                                method: "GET",
                                dataType: "json",
                                async: false,
                                data: {'shopname': store_url, 'meta_id': metaid, 'metavalue': metavalue},
                                success: function (response) {
                                  debugger;
                                  var meta_id = response.body.metafield.id;
                                            
                                    $.ajax({
                                        url: base_url + 'SaveMetaDataDatabase',
                                        method: "GET",
                                        dataType: "json",
                                        async: false,
                                        data: {'cart_token': gettoken, 'meta_id': meta_id,'metavalue':metavalue},
                                        success: function (Res) {
                                            debugger;
                                          	
                                          var discount_price=$('#dis_amt').val();
                                          
                                          	 $.ajax({
                                                  url: base_url + 'GenerateDiscountCode',
                                                  method: "GET",
                                                  dataType: "json",
                                                  async: false,
                                                  data: {'discount_amount':discount_price,store_url:store_url},
                                                  success: function (response) {
                                                    debugger;
                                                    $('#cart').find('.discount_code').remove();
                                                    
                                                    $('#cart').append('<input type="hidden" class="discount_code" name="discount" value="'+response.DiscountCode+'">');
                                                    
                                                    $('.loader').hide();
                                                    
                                                    $('form[action="/checkout"]').submit();
                                                  },
                                                  error:function(){
                                                    console.log("error");
                                                  }
                                             });
                                          
                                          	
                                          
                                        },
                                        error:function(){
                                          console.log("error");
                                        }	
                                    });
                                  
                                },
                                error:function(){
                                    console.log("error");
                                }
                         });
                     // }
                      
                    },
                    error:function(){
                    	console.log('error');
                    }
               });
              
            },
             error:function(){
             console.log('error');
             }
         });
    }else{
      $('#cart').find('.discount_code').remove();
       $('#cart').append('<input type="hidden" class="discount_code" name="discount" value=" ">');
    	$('form[action="/checkout"]').submit();
    }
    	
    
  });
  
  
  
  if(templatename == "cart"){
   $('.loader_image').show();
    	  $.ajax({
              url: '/cart.js',
              method: "GET",
              dataType: "json",
              async: false,
              success: function (response) {
                var item_count = response.item_count;
                if(item_count != 0){
                    var total_plan_price=0;
                    var total_rec_pri=0;
                    var brush_type="";
                    var a=0;
                    var discountprice=0;
                  	var price_amt=0;
                    var flag=0;
                    for(var i=0;i< response.items.length;i++){
                      var pro_type=response.items[i].product_type;
                      if(pro_type.indexOf("kids") != -1){
                          brush_type="kids"
                      }
                      if(pro_type.indexOf("adults") != -1){
                          brush_type="adults"
                      }

                      $.ajax({
                            url: base_url + 'Getplan',
                            method: "GET",
                            dataType: "json",
                            data:{brush_type:brush_type},
                            async: false,
                            success: function (res) {
                              debugger;
                              if(res.length > 0){

                                 $.ajax({
                                        url: base_url + 'PlanName',
                                        method: "GET",
                                        dataType: "json",
                                        data:{cart_token:response.token,'pro_id':response.items[i].product_id},
                                        async: false,
                                        success: function (data) {
                                          debugger;
                                          $('#planname').remove();
                                          $('#plan_info').remove();
                                          $('#dis_amt').remove();
                                          $('#checkout').after('<input type="hidden" id="planname" value="'+flag+'">');
                                          $('#checkout').after('<input type="hidden" id="dis_amt" value="">');
                                          $('.plan_detail').after('<div id="plan_info"></div>');

                                          var price= response.items[i].price;
                                          var item_price=price.toString();
                                          var amt= (item_price.substring(0,item_price.length-2)+"."+item_price.substring(item_price.length-2))*response.items[i].quantity;
                                          for(var j=0;j<res.length;j++){
                                              if(data.plan_name == res[j].plan_name){
                                                total_plan_price= total_plan_price + (res[j].plan_price * response.items[i].quantity);
                                                total_rec_pri = total_rec_pri + (res[j].recurring_price * response.items[i].quantity);

                                                $(".price_total")[a].innerText="$ "+res[j].plan_price+" USD";
												
                                                
                                                
                                                discountprice = discountprice + (amt -  (res[j].plan_price * response.items[i].quantity));

                                                flag=1;
                                                $('#planname').val("1");
                                                
                                                price_amt= price_amt + res[j].plan_price * response.items[i].quantity;

                                              }else{
                                              	price_amt = price_amt + parseFloat(amt);
                                              }
                                        }



                                        },
                                       error:function(){
                                         debugger;
                                         console.log("error");
                                       }
                                   });




                              }

                            },
                           error:function(){
                            console.log('error');
                           }
                        });

                        a++;
                    }

                      var dis_amt=discountprice.toFixed(2);

                      $('#dis_amt').val(dis_amt);

                    var Planname=$('#planname').val();

                    if(flag != 0){
                        var plan_detail='<div class="product_price price_plan_3"><span>$'+total_plan_price+'<small>Today</small></span><span class="dec_price">$'+total_rec_pri+'*<small>Every 3 Month</small></span></div>';
                      plan_detail+= "<div class='plan_description_3'>*This amount will be charged once every 3 Months, when your next refill pack is ready to ship. To view details or cancel any time, visit <a target='_blank' href='/account'>your&nbsp;profile</a> or <a href='javascript:void(0)'>contact us</a>.</div>";
					
                      var total_amt="<strong><span class='money'>$"+price_amt+" USD</span></strong><small class='excluding_tax'><em>Excluding tax &amp; shipping</em></small>"
                      
                       $('#plan_info').html(plan_detail);
                       $('.subtotal_amount').html(total_amt);	
                    }
                }
              },
              error:function(){
				console.log('error');
              }	
          });
    
    $('.loader_image').hide();

  	
  }
  
  if(templatename == "account"){
  
    $('#cancel_subscription').on('click',function(){
    	debugger;
      var cust_email=$(this).attr('data-id');	
      
      if (confirm("if you will cilck on cancel subscription than all your subscibe plan is cancel")) {
      
          $.ajax({
                url: base_url + 'Cancel_subscription',
                method: "GET",
                dataType: "json",
                data:{cust_email:cust_email},
                async: false,
                success: function (res) {
                  debugger;
                  if(res == 1){
                    
                    $('#cancel_subscription').after('<span style="color:green">Subscription Canceled</span>')
                    
                    setTimeout(function(){
                    	window.location.reload();
                    },3000);
                  	
                  }
                  
                  if(res == 0){
                    $('#cancel_subscription').after('<span style="color:red">You have no subscription active</span>')

                      setTimeout(function(){
                          window.location.reload();
                      },3000);
                    }
                  
                },
                error:function(){
                    console.log("error");
                }
          });
      }
    });
  
  }
  
});